import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


import { SettingsComponent } from './settings.component';
import { UserInfoComponent } from './components/user-info/user-info.component';


const routes: Routes = [
  {
    path: '', component:SettingsComponent,children:[
        {
            path: "userinfo",
            component: UserInfoComponent
        },
        {
          path: '',
          redirectTo: 'userinfo',
          pathMatch: 'full'
        }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }